import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  width: 100%;
  margin: 24px 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 16px;
`;

export const ItemContainer = styled.div`
  width: calc(50% - 8px);
  color: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  background-color: transparent;
  padding: 16px;

  .title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};
    margin-bottom: 24px;

    .slider {
      margin-left: 8px;
    }
  }

  .values {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;

    .label {
      font-size: 12px;
      font-weight: 300;
      color: ${colors.silver};
      letter-spacing: 1px;
      margin-bottom: 5px;
      white-space: nowrap;
    }

    .checkInTimeContainer,
    .checkOutTimeContainer {

    }
  }
`;
